import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const columns: TableColumn[] = [
  { id: 'name', label: 'Name', align: 'left', sortDisabled: false, width: '250px' },
  { id: 'amount', label: 'Limit', align: 'left', sortDisabled: true, width: '150px' },
  { id: 'actions', label: 'Actions', align: 'right', sortDisabled: true },
];

export const availableParams = [{ label: 'Wind speed', id: 'wind-speed', units: 'm/s' }];

export const getUnitsByName = (name: string) => availableParams.find((x) => x.label === name)?.units || '';
